import StringCell from "@isceco/widget-library2/basic-elements/List/cell/StringCell.js";

export default class PercentageCell extends StringCell {
  constructor() {
    super();
  }

  render(value, row) {
    if (row === null || row === undefined || row === '') {
      return '';
    }
    return `${row} %`;
  }
}
